export const sectionWiseChartReportData=(data:any)=>{
try{
  const labelsOfSection:string[]=[];
  const sectionWiseTotal:number[]=[];
  const sectionWiseTotalObtained:number[]=[];
  data.map(async(item:any)=>{
    labelsOfSection.push(item?.sectionName)
    sectionWiseTotal.push(item?.totalMark)
    sectionWiseTotalObtained.push(item?.totalMarkObtained)
  })
 return {labelsOfSection,sectionWiseTotalObtained,sectionWiseTotal}
}catch(err){
    console.log(err,":error on section wise chart report data generation")
}
}

//-----------------centa-----------------------------------------------------------------------------------------

// export const sectionWiseChartReportData=(data:any)=>{
// try{
//   const labelsOfSection:string[]=[];
//   const percentageArray:number[]=[];
//   // const sectionWiseTotalObtained:number[]=[];
//   data.map(async(item:any)=>{
//     labelsOfSection.push(item?.sectionName)
//     let percentage= await (parseInt(item?.totalMarkObtained)/parseInt(item?.totalMark))*100
//      percentageArray.push(percentage)
//     // sectionWiseTotal.push(item?.totalMark)
//     // sectionWiseTotalObtained.push(item?.totalMarkObtained)
//   })
// //  return {labelsOfSection,sectionWiseTotal,sectionWiseTotalObtained}
//  return {labelsOfSection,percentageArray}
// }catch(err){
//     console.log(err,":error on section wise chart report data generation")
// }
// }